<template>
  <div>
    <section id="contact" class="content-wrapper page">
      <section class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>

          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Contact
          </li>
        </ul>
        <div class="col contact-intro">
          <h1>Contact</h1>
          <p>
            Heeft u een vraag en/of opmerking, of wilt u in contact komen met
            één van onze medewerkers?<br />Vul het contactformulier in en wij
            nemen zo spoedig mogelijk contact met u op.
          </p>
          <p>
            U kunt ook bellen op nummer 088 425 68 00.<br />Wij zijn van maandag
            t/m vrijdag van 8.30 uur tot 17.00 uur bereikbaar.
          </p>
        </div>
        <div class="col col-map">
          <contact-map @select-vestiging="selectVestiging"></contact-map>

          <div class="bg-circle g-w"></div>
        </div>
      </section>
      <section class="row contact-holder">
        <div class="col-single">
          <contact-form title="Contactformulier"></contact-form>
        </div>
      </section>
      <section id="vestigingen" class="row vestigingen">
        <div class="">
          <h1>Wij zijn gevestigd door heel Nederland</h1>

          <div class="address-row">
            <!--  <div
              id="shop-leeuwarden"
              class="vestiging"
              :class="{ active: shop == 'leeuwarden' }"
            >
              <h3>Noord Nederland</h3>
              <p>
                Harlingersingel 11<br />
                8913 CJ Leeuwarden<br />
                <a href="tel:0582987198">Tel. 058 298 71 98</a><br />
                <a href="mailto:leeuwarden@rijnja.nl">leeuwarden@rijnja.nl</a>
              </p>
            </div> -->

            <div
              id="shop-heerde"
              class="vestiging"
              :class="{ active: shop == 'heerde' }"
            >
              <h3>Noordoost Nederland</h3>
              <p>
                Europaweg 9<br />
                8181 BG Heerde<br />
                <a href="tel:0384250325">Tel. 038 425 03 25</a><br />
                <a href="mailto:heerde@rijnja.nl">heerde@rijnja.nl</a>
              </p>
            </div>

            <div
              id="shop-amsterdam"
              class="vestiging"
              :class="{ active: shop == 'amsterdam' }"
            >
              <h3>Noord-Holland</h3>
              <p>
                Zekeringstraat 46<br />
                1014 BT Amsterdam<br />
                <a href="tel:0206114304">Tel. 020 611 43 04</a><br />
                <a href="mailto:amsterdam@rijnja.nl">amsterdam@rijnja.nl</a>
              </p>
            </div>

            <div
              id="shop-denhaag"
              class="vestiging"
              :class="{ active: shop == 'den-haag' }"
            >
              <h3>Zuid-Holland</h3>
              <p>
                Laan van Ypenburg 84<br />
                2497 GB Den Haag<br />
                <a href="tel:0703769933">Tel. 070 376 99 33</a><br />
                <a href="mailto:denhaag@rijnja.nl">denhaag@rijnja.nl</a>
              </p>
            </div>

            <div
              id="shop-utrecht"
              class="vestiging"
              :class="{ active: shop == 'nieuwegein' }"
            >
              <h3>Midden Nederland</h3>
              <p>
                Ravenswade 2B<br />
                3439 LD Nieuwegein<br />
                <a href="tel:0302849252">Tel. 030 284 92 52</a><br />
                <a href="mailto:utrecht@rijnja.nl">utrecht@rijnja.nl</a>
              </p>
            </div>
          </div>
          <div class="address-row">
            <div
              id="shop-boxtel"
              class="vestiging"
              :class="{ active: shop == 'boxtel' }"
            >
              <h3>Zuidoost Nederland</h3>
              <p>
                Ladonkseweg 9<br />
                5281 RN Boxtel<br />
                <a href="tel:0402501210">Tel. 040 250 12 10</a><br />
                <a href="mailto:boxtel@rijnja.nl">boxtel@rijnja.nl</a>
              </p>
            </div>

            <div
              id="shop-beegden"
              class="vestiging"
              :class="{ active: shop == 'beegden' }"
            >
              <h3>Zuid Nederland</h3>
              <p>
                Beegderveld 9<br />
                6099 NC Beegden<br />
                <a href="tel:0475222010">Tel. 0475 22 20 10</a><br />
                <a href="mailto:beegden@rijnja.nl">beegden@rijnja.nl</a>
              </p>
            </div>
          </div>
          <div class="address-row">
            <div
              id="shop-hoofdkantoor"
              class="vestiging"
              :class="{ active: shop == 'hoofdkantoor' }"
            >
              <h3>Administratie</h3>
              <p>
                Ravenswade 2B<br />
                3439 LD Nieuwegein<br />
                <a href="tel:0302849317">Tel. 030 28 49 317</a><br />
                <a href="mailto:crediteurenadministratie@rijnja.nl"
                  >crediteurenadministratie@rijnja.nl</a
                ><br />
                <a href="mailto:debiteurenadministratie@rijnja.nl"
                  >debiteurenadministratie@rijnja.nl</a
                >
              </p>
            </div>

            <div class="vestiging">
              <h3>Verkoop</h3>
              <p>
                <a href="tel:0302849309">Tel. 030 28 49 309</a><br />
                <a href="mailto:verkoop@rijnja.nl">verkoop@rijnja.nl</a>
              </p>
            </div>

            <div
              id="shop-helpdesk"
              class="vestiging documenten"
              :class="{ active: shop == 'helpdesk' }"
            >
              <h3>Algemeen</h3>
              <p>
                <a href="tel:0884256800">Tel. 088 425 68 00</a><br />
                <router-link to="/leveringsvoorwaarden"
                  >leveringsvoorwaarden</router-link
                >

                <br />
                <router-link to="/privacyverklaring"
                  >privacyverklaring</router-link
                >
              </p>
            </div>
          </div>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
import ContactForm from '../../components/ContactForm.vue'
import ContactMap from './ContactMap.vue'

export default {
  props: ['contactShop'],
  data() {
    return {
      shop: ''
    }
  },
  computed: {},
  components: {
    SiteFooter,
    ContactForm,
    ContactMap
  },
  methods: {
    selectVestiging(shop) {
      this.shop = shop

      document
        .getElementById('vestigingen')
        .scrollIntoView({ behavior: 'smooth' })
    }
  },
  mounted() {
    this.rootStore.setFullscreen(true)

    if (this.contactShop) {
      setTimeout(() => {
        this.selectVestiging(this.contactShop)
      }, 250)
    }
  },
  beforeUnmount() {
    this.rootStore.setFullscreen(false)
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

.row.contact-holder {
  justify-content: center;

  .col-single {
    text-align: left;
    width: 100%;
    max-width: 850px;
  }
}

.col-map {
  text-align: center;
  //padding-top: 30px;
}

#contact .vestigingen {
  align-items: flex-start;

  > div {
    flex: 1 1 auto;
  }
  h1 {
    margin: 20px 0;
  }
}

.address-row {
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  //  justify-content: space-between;
}

.vestiging {
  width: 100%;
  margin-bottom: 15px;

  h3 {
    color: #012169;
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 5px;
  }

  p {
    padding-top: 0;
  }

  a {
    text-decoration: none;
  }

  &.active {
    box-shadow: rgba(0, 0, 0, 33%) 0 0 28px -12px;
  }
}

.map-container {
  display: none;
}

@media only screen and (min-width: 768px) {
  .row.contact-holder {
    padding: 0;
  }

  .vestiging {
    text-align: left;
    width: 210px;
    padding: 30px;
    border-radius: 25px;
    margin-bottom: 0;
    flex: 0 1 25%;
    justify-content: flex-start;
  }

  .map-container {
    display: inline-block;
    max-width: 300px;
    position: relative;
  }
}
</style>
